import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Root = styled.div`
    border-top: 2px solid ${theme.color.midnight40};
`;
